const SET_JOB_ALERTS = 'SET_JOB_ALERTS';
const ADD_OFFERS_TO_JOB_ALERT = 'ADD_OFFERS_TO_JOB_ALERT';

const setJobAlerts = jobAlerts => ({
  type: SET_JOB_ALERTS,
  payload: {
    jobAlerts
  }
});

const addOffersToJobAlert = ({ id, offers }) => ({
  type: ADD_OFFERS_TO_JOB_ALERT,
  payload: {
    id,
    offers
  }
});

const convertJobAlert = jobAlert => ({
  ...jobAlert,
  offers: null,
  active: !jobAlert.channels.some(({ isActive }) => !isActive),
  criterias: jobAlert.criteria
    .filter(({ value }) => value)
    .map(criteria => Object.values(criteria))
    .map(([key, value]) => ({ [key]: encodeURIComponent(value) }))
    .reduce((previous, curr) => ({ ...previous, ...curr }), {})
});


export {
  ADD_OFFERS_TO_JOB_ALERT,
  SET_JOB_ALERTS,
  convertJobAlert,
  setJobAlerts,
  addOffersToJobAlert
};
